<template>
    <div>
        <AppButton element="button" type="button" @click="open = !open" desired-action>
            {{ $t('messages.assign_evaluation_criteria') }}
        </AppButton>
        <SlideOver :title="$tc('messages.evaluation_criteria', 2)" :show="open" @close="close()">
            <div class="p-2">
                <div>{{ questionsIds.length }} {{ $tc('messages.questions', questionsIds.length) }}</div>
                <form :action="endpoint" method="post" @submit.prevent="submit" class="mt-3">
                    <div v-if="evaluationCriteria.length === 0">
                        <EmptyState :title="$t('messages.there_are_no_evaluation_criteria')" with-icon with-button>
                            <template v-slot:button>
                                <AppButton element="InertiaLink" :href="evaluationCriteriaLink">
                                    {{ $t('messages.create') }}
                                </AppButton>
                            </template>
                        </EmptyState>
                    </div>
                    <ul v-else>
                        <li v-for="evaluationCriterion in evaluationCriteria" :key="evaluationCriterion.value">
                            <Tippy>
                                <label>
                                    <input
                                        v-model="form.evaluation_criterion_ids"
                                        :value="evaluationCriterion.value"
                                        type="checkbox"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded mr-1"
                                    />
                                    {{ evaluationCriterion.text }}
                                </label>

                                <template #content>
                                    <div>
                                        {{ evaluationCriterion.grade_level_names }}
                                    </div>
                                    <div>
                                        <p class="whitespace-pre-line italic">{{ evaluationCriterion.description }}</p>
                                    </div>
                                    <div class="mt-3">
                                        <ul>
                                            <li v-for="dimension in evaluationCriterion.dimensions" :key="dimension.id">
                                                {{ dimension.abbreviation }} - {{ dimension.title }}
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </Tippy>
                        </li>
                    </ul>

                    <div>
                        <FormError :value="form.errors['question_ids']" class="mt-2 max-w-sm" />
                        <FormError :value="form.errors['evaluation_criterion_ids']" class="mt-2 max-w-sm" />
                    </div>
                    <div class="flex space-x-2 justify-end mt-5">
                        <AppButton element="button" @click="remove()" :disabled="form.processing">
                            {{ $t('messages.remove') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                        </AppButton>
                        <AppButton desired-action element="button" @click="submit('add')" :disabled="form.processing">
                            {{ $t('messages.add') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                        </AppButton>
                        <AppButton
                            desired-action
                            element="button"
                            @click="submit('replace')"
                            :disabled="form.processing"
                        >
                            {{ $t('messages.replace') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                        </AppButton>
                    </div>
                </form>
            </div>
        </SlideOver>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import AppButton from '@/components/AppButton.vue';
import FormError from '@/components/Forms/FormError.vue';
import { Tippy } from 'vue-tippy';
import EmptyState from '@/components/EmptyState.vue';

export default {
    name: 'ActivityQuestionsEvaluationCriteriaPanel',
    components: {
        EmptyState,
        SlideOver,
        AppButton,
        FormError,
        Tippy,
    },
    props: {
        questionsIds: {
            required: true,
            type: Array,
        },
        evaluationCriteria: {
            required: true,
            type: Array,
        },
        endpoint: {
            required: true,
            type: Object,
        },
        evaluationCriteriaLink: {
            type: String,
            required: true,
        },
    },
    emits: ['finished'],
    data() {
        return {
            open: false,
            url: null,
            form: this.$inertia.form({
                question_ids: this.questionsIds,
                evaluation_criterion_ids: [],
            }),
        };
    },
    methods: {
        submit(mode) {
            const urls = {
                add: this.endpoint.attach_evaluation_criteria,
                replace: this.endpoint.replace_evaluation_criteria,
            };
            const url = urls[mode];
            this.form.patch(url, {
                onSuccess: () => {
                    this.closeAndReset();
                },
            });
        },
        remove() {
            this.$inertia.delete(this.endpoint.remove_evaluation_criteria, {
                data: {
                    question_ids: this.questionsIds,
                },
                onSuccess: () => {
                    this.closeAndReset();
                },
            });
        },
        close() {
            this.form.clearErrors();
            this.open = false;
        },
        closeAndReset() {
            this.form.reset('evaluation_criterion_ids');
            this.$emit('finished');
            this.close();
        },
    },
    watch: {
        questionsIds(newVal) {
            this.form.question_ids = newVal;
        },
    },
};
</script>
